import Box from "@mui/material/Box";
import ActionBox from "components/UploadPage/MainContainer/ActionBox";
import TimeBox from "components/UploadPage/MainContainer/TimeBox";
import LayersBox from "components/UploadPage/MainContainer/LayersBox";
import TimeRuler from "components/UploadPage/MainContainer/TimeRuler";
import "./index.scss";

const MainContainer = () => {
    return (
        <Box className='center-wrapper'>
            <Box className='timeline-slider'>
                <TimeRuler />
            </Box>
            <Box className="layers-box">
                <LayersBox />
            </Box>
            <Box className='time-box'>
                <TimeBox />
            </Box>
            <Box className='action-box'>
                <ActionBox />
            </Box>
        </Box>
    )
}

export default MainContainer